/**
 * Wire format for a computed statistic.
 *
 * Every statistic materialises into the same table shape so a single component
 * renders all of them, and adding a statistic needs no new UI. Anything a
 * statistic wants to say beyond numbers goes in `note` or `headline`.
 */
/** The key every row carries its identity under. Not a column; never rendered. */
export const STAT_ROW_ID = 'id';
/**
 * The key a row carries the Sleeper user id of the manager it belongs to under.
 *
 * Not a column either: it exists so the client can tell a reader which row is
 * theirs without matching on a display name, which is exactly the thing that
 * changes. Null on a row that belongs to nobody — a rookie the league never
 * drafted, say.
 */
export const STAT_ROW_OWNER = 'owner';
/** The season key used for the "All Seasons" tab. */
export const ALL_SEASONS = 'ALL';
/**
 * Weeks the current season has to have in the books before the home page's
 * statistic of the week is drawn from it rather than from every season at once.
 */
export const FEATURED_SEASON_MIN_WEEKS = 3;
/**
 * Which season tab the statistic of the week reads from.
 *
 * Three games decide nothing: a table built on the first weeks of a season says
 * more about the schedule than about the teams, and whoever leads it usually
 * just drew the easiest opponents. So the season only takes over once three of
 * its weeks are settled — which also covers the offseason, when the season
 * about to be played has none.
 */
export function pickFeaturedSeason(currentSeason, completedWeeks) {
    if (!currentSeason)
        return ALL_SEASONS;
    return completedWeeks >= FEATURED_SEASON_MIN_WEEKS ? currentSeason : ALL_SEASONS;
}
//# sourceMappingURL=stats.js.map